import { render, staticRenderFns } from "./TipoDeVacina.vue?vue&type=template&id=27368e82&"
import script from "./TipoDeVacina.vue?vue&type=script&lang=js&"
export * from "./TipoDeVacina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports